<template>
    <div class="display_object_container">
        <div class="screen">
            <el-button type="primary" @click="new_exhibition" v-access:add v-if="hasAccess('245')">+新建展示对象</el-button>
            <span class="btn" @click="open_screen">筛选</span>
        </div>
        <CommonTable5 :tableTitle="tableTitle" :tableData="tableData" :btnList="btnList1"/>
        <Rawer :drawer="drawer" :direction="direction" :rawer_list="rawer_list" @screen="screen" @handleClose_drawer="handleClose_drawer"></Rawer>
        <PaginationModular @set_page="set_page" @set_limit="set_limit" 
            :data_obj="data_obj" :page="page" :limit="limit"
            />
        <el-dialog
        title="提示"
        :visible.sync="dialogVisible"
        width="400px"
        :before-close="handleClose_dialog">
        <span style="padding:20px">确定删除该条数据吗？</span>
        <span slot="footer" class="dialog-footer">
            <el-button @click="dialogVisible = false">取 消</el-button>
            <el-button type="primary" @click="dialog_del">确 定</el-button>
        </span>
        </el-dialog>
    </div>
</template>

<script>
import { hasAccess } from '@/common/utils'
import CommonTable5 from '@/components/commonTable5.vue'
import Rawer from '@/components/drawer/drawer'
import PaginationModular from '@/components/pagination_modular/pagination_modular.vue'
export default {
    components:{
        CommonTable5,
        PaginationModular,
        Rawer
    },
    data(){
        return{
            hasAccess,
            dialogVisible:false,
            del_id:0,
            page:1,
            limit:10,
            data_obj:{},
            drawer:false,//筛选
            direction:'rtl',//筛选框打开的方向
            btnList1:[
                {
                    _this:this,
                    btn:"查看",
                    acces_id:'244',
                    fun(val){
                        this._this.router.push({path:"/new-display-objec",query:{type:'look',id:val.id}});
                    }
                },
                {
                    _this:this,
                    btn:"编辑",
                    acces_id:'246',
                    fun(val){
                        this._this.router.push({path:"/new-display-objec",query:{type:'edit',id:val.id}});
                    }
                },
                {
                    _this:this,
                    btn:"删除",
                    acces_id:'247',
                    fun(val){
                        this._this.del_id = val.id
                        this._this.dialogVisible = true
                    }
                },
            ],
            //项目征集表头
            tableTitle:[
                {label:'展示对象ID',prop:'id'},
                {label:'展示对象名称',prop:'name'},
                {label:'入口密码',prop:'password'},
                {label:'展示资源数',prop:'display_num'},
                {label:'创建时间',prop:'updated_at'}
            ],
            tableData:[],
            rawer_list:[
                {label:'展示对象ID',prop:'id',open_id:'',placeholder:"请输入用户ID检索",},
                {label:'展示对象名称',prop:'name',username:'',placeholder:"请输入用户昵称检索"},
            ],
        }
    },
    mounted(){
        this.init()
    },
    methods:{
        dialog_del(){
            this.api.oppowallpaper_delChannel({id:this.del_id}).then((data) => {
                this.$message({
                    message: data,
                    type: 'success'
                });
                this.dialogVisible = false
                this.init()
            }).catch(() => {
            });
        },
        handleClose_dialog(){
            this.dialogVisible = false
        },
        set_limit(val){
            this.page = 1
            this.limit = val
        },
        set_page(val){
            this.page = val
            this.init()
        },
        init(data){
            let params = data?data:{
                page:this.page,
                limit:this.limit
            }
            this.api.oppowallpaper_channelList(params).then((data) => {
                this.tableData = data.data
                this.data_obj = data
            }).catch(() => {
            });
        },
        new_exhibition(){
            this.router.push({path:"/new-display-objec"});
        },
        open_screen(){
            this.drawer = true
        },
        handleClose_drawer(){
            this.drawer = false
        },
        //筛选事件
        screen(val){
            let params = {
                page:this.page,
                limit:this.limit,
                ...val
            }
            this.init(params)
            this.drawer = false
        }
    }
}
</script>

<style lang="scss" scoped>
.display_object_container{
    width: 100%;
    .btn{
        cursor:pointer
    }
    .screen{
        display: flex;
        justify-content: space-between;
        padding: 10px 30px;
    }
}
</style>